import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=12590200&scoped=true&"
import script from "./Viewer.vue?vue&type=script&lang=ts&"
export * from "./Viewer.vue?vue&type=script&lang=ts&"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=12590200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12590200",
  null
  
)

export default component.exports